module.exports = new __parcel__URL__("hide-ex.c1f670aa.mp3").toString();